import { render, staticRenderFns } from "./myWrongQuestions.vue?vue&type=template&id=35ea1694&scoped=true"
import script from "./myWrongQuestions.vue?vue&type=script&lang=js"
export * from "./myWrongQuestions.vue?vue&type=script&lang=js"
import style0 from "./myWrongQuestions.vue?vue&type=style&index=0&id=35ea1694&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ea1694",
  null
  
)

export default component.exports